import { setRangeMin } from './helpers';

export const setPriceMin = setRangeMin('price');
